import { selfDeliveryRequestStatuses } from 'shared/helpers/constants/selfDeliveryRequests/selfDeliveryRequestStatuses';

const selfDeliveryRequestStatusChangeAccess = (auth, selfDeliveryRequest) =>
  auth.access.selfDeliveryRequests.details.approve &&
  selfDeliveryRequest.status === selfDeliveryRequestStatuses.submitted;

export { selfDeliveryRequestStatusChangeAccess };
